import { useQuery } from "@tanstack/react-query";
import { fetchFirmWorkload, type FirmWorkload } from "../api/firmWorkload";

export function useFirmWorkload() {
  return useQuery<FirmWorkload>({
    queryKey: ["firm", "workload"],
    queryFn: fetchFirmWorkload,
    staleTime: 60_000,
  });
}
